import * as sentry from '@sentry/browser';
import apolloClient from 'services/apollo-client';
import { surfaceNodesQuery } from 'graphql/surface-node/queries/surface-nodes';
import { set, isFunction } from 'lodash/fp';

export function useSaveNodesInCache(surfaceId: string) {
  return function saveNodesInCache(nodes, cache = apolloClient) {
    const variables = {
      input: { filter: { surface: surfaceId } },
    };

    try {
      const { surfaceNodes } = cache.readQuery<any>({
        query: surfaceNodesQuery,
        variables,
      });

      let newNodes = isFunction(nodes) ? nodes(surfaceNodes.nodes) : nodes;

      newNodes = newNodes.map((node) => {
        if (node.originalNode) {
          return node;
        }

        return set('originalNode', null, node);
      });

      cache.writeQuery({
        query: surfaceNodesQuery,
        data: {
          surfaceNodes: set('nodes', newNodes, surfaceNodes),
        },
        variables,
      });
    } catch (error) {
      console.error('------------- saveNodesInCache -----------------');
      console.error(error);
      sentry.captureException(error);
    }
  };
}

export default useSaveNodesInCache;
